import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAsyncActions } from 'react-async-client';

import { getDictionaryUrl } from 'constants/urls';
import { getDictionary } from 'actions/asyncActions';
import withLanguageContext from './withLanguageContext';

export default WrappedComponent => {
    class Load extends Component {
        static propTypes = {
            dictionaryAction: PropTypes.object.isRequired
        };

        render() {
            const { data, meta } = this.props.dictionaryAction;

            return (
                <WrappedComponent
                    {...this.props}
                    options={data}
                    loading={meta.pending}
                    pending={meta.pending}
                />
            );
        }
    }

    const dictionaryUrl = props => getDictionaryUrl({ loadName: props.loadName, language: props.language, params: props.loadParams });

    return withLanguageContext(withAsyncActions({
        dictionaryAction: getDictionary
            .withPayload(dictionaryUrl)
            .withParams(dictionaryUrl)
            .withOptions({ dispatchOnMount: true, dispatchOnUpdate: true })
    })(Load));
};
